import { SiteFiltersStore } from "../store";
import { sanitiseVueObservable } from "../../../helpers/sanitiseVueObservable";
import { useSnapshot } from "valtio";

export const useAssignees = (store: SiteFiltersStore) => {
  const { assignees } = useSnapshot(store);
  return sanitiseVueObservable(assignees) as string[];
};
